export const useMarkScreenInteractive = () => {
  // no measure of tti on web
}
